import { render, staticRenderFns } from "./Juridica.vue?vue&type=template&id=c4bc7d1c&scoped=true&"
import script from "./Juridica.vue?vue&type=script&lang=js&"
export * from "./Juridica.vue?vue&type=script&lang=js&"
import style0 from "./Juridica.vue?vue&type=style&index=0&id=c4bc7d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bc7d1c",
  null
  
)

export default component.exports